module.exports = __webpack_public_path__ + "static/media/traffic-no.3b64dd6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traffic-no.svg
// module id = 423
// module chunks = 0